import reportModal from "./modal";
import onReady from '../../helpers/onReady'

onReady(() => {
  $('body').on('click', '.js-report-link', function (e) {
    reportModal(e);
  });
});